import * as React from 'react';
import { z } from "zod";
import Typography from '@mui/material/Typography';
import { Container, Alert, Snackbar, Button, TextField, Box, IconButton, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { fetchCustomerSupportRepairReplacements, updateCustomerSupportRepairReplacement, deleteCustomerSupportRepairReplacement, emailCustomerSupportRepairReplacementPdf, fetchCustomers, fetchSolutions, fetchVehicles, fetchTechnicalComplaint as fetchTechnicalComplaintApi } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';
import { FormModal, RHFTextField } from "../components/form";

export function CustomerSupportRepairReplacement() {
  const [haulierOptions, setHaulierOptions] = React.useState([]);
  const [truckOptions, setTruckOptions] = React.useState([]);
  const [devicesOptions, setDevicesOptions] = React.useState([]);
  const [sendingEmailId, setSendingEmailId] = React.useState(null);
  const [vehicleData, setVehicleData] = React.useState([]);
  const [imeiData, setIMEIData] = React.useState([]);
  const [selectedSale, setSelectedSale] = React.useState(null);
  const [saleModalOpen, setSaleModalOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
    const [searchVehicle, setSearchVehicle] = React.useState('');
const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};

  const fetchTrucks = async () => {
    try {
      const response = await fetchCustomerSupportRepairReplacements();
      setCustomerSupportData(response.data);
      showSnackbar('Customer Support fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching Customer Support Data';
      showSnackbar(`Failed to fetch Customer Support Data: ${errorMessage}`, 'error');
    }
  };
  const handleViewSaleDetail = async (saleId) => {
    try {
      const response = await fetchTechnicalComplaintApi(saleId);
      console.log(response.data);
      setSelectedSale(response.data);
      setSaleModalOpen(true);
    } catch (error) {
      console.error("Failed to fetch sale detail:", error);
    }
  };
  const fetchHauliers = async () => {
    try {
      const response = await fetchCustomers();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.client_name;
        return acc;
      }, {});
      setHaulierOptions(haulierDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchDevices = async () => {
    try {
      const response = await fetchSolutions();
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setDevicesOptions(deviceDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };

  const fetchTruck = async () => {
    try {
      const response = await fetchVehicles();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.registration_number;
        return acc;
      }, {});
      setTruckOptions(haulierDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const handleSendEmail = async (saleId) => {
    setSendingEmailId(saleId);

    try {
      await emailCustomerSupportRepairReplacementPdf(saleId, {});
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Email error:", error);
      alert("Failed to send email.");
    } finally {
      setSendingEmailId(null);
    }
  };

  React.useEffect(() => {
    fetchTrucks();
    fetchHauliers();
    fetchDevices();
    fetchTruck();
  }, []);

  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const [customerSupportData, setCustomerSupportData] = React.useState([])
  // Save customerSupportData to localStorage on update
  React.useEffect(() => {
    localStorage.setItem('customerSupport', JSON.stringify(customerSupportData));
    console.log(customerSupportData, 'customerSupportData');

  }, [customerSupportData]);
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [selectedCustomerSupport, setSelectedCustomerSupport] = React.useState(null);
  const handleEditOn = (device) => {
    setSelectedCustomerSupport(device);
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setSelectedCustomerSupport(null);
  };
  const handleDelete = async (id) => {
    try {
      await deleteCustomerSupportRepairReplacement(id);
      showSnackbar("Customer deleted successfully", "success");
    } catch (error) {
      showSnackbar("Failed to delete customer", "error");
      console.error(error);
    }
  };
  const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a3');

  // Title
  doc.setFontSize(18);
  doc.text('Customer Support Repair Replacement Report', 14, 16);

  // Match UI table headers
  const columns = [
    'Repair/Replacement #',
    'Customer Support Complaint #',
    'Technical Complaint #',
    'Amount',
    'Document',
    'Close At',
    'Status',
  ];

  // Map rows to match columns
  const tableData = customerSupportData.map(record => [
    record.id, // Repair/Replacement #
    record.customer_support_complaint || '',
    record.technical_complaint || '',
    record.amount || '',
    record.document_url ? "Available" : "Not Available",
    record.status === "Close"
      ? record.updated_at?.slice(0, 19).replace("T", " ")
      : '',
    record.status || '',
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 3,
    },
    columnStyles: {
      0: { cellWidth: 40 }, // Repair/Replacement #
      1: { cellWidth: 55 }, // Customer Support Complaint #
      2: { cellWidth: 55 }, // Technical Complaint #
      3: { cellWidth: 35 }, // Amount
      4: { cellWidth: 50 }, // Document
      5: { cellWidth: 50 }, // Close At
      6: { cellWidth: 35 }, // Status
    },
    theme: 'grid',
    didDrawPage: () => {
      doc.setFontSize(18);
      doc.text('Customer Support Repair Replacement Report', 14, 16);
    },
  });

  doc.save('Customer_Support_Repair_Replacement_Report.pdf');
};

  const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
      await updateCustomerSupportRepairReplacement(saleId, updatedSale);
      setCustomerSupportData((prevData) =>
        prevData.map((item) =>
          item.id === saleId ? { ...item, status: newStatus } : item
        )
      );

      showSnackbar('Status updated successfully', 'success');
    } catch (error) {
      console.error('Failed to update status:', error);
      showSnackbar('Failed to update status', 'error');
    }
  };
  const filteredCustomerSupportData = searchVehicle
    ? customerSupportData.filter((sale) =>
      truckOptions[sale.vehicle_details?.id]
        ?.toLowerCase()
        .includes(searchVehicle.toLowerCase())
    )
    : customerSupportData;
  return (
    <Container maxWidth="xl" sx={{ m: 2 }}>
      {editModalOpen && selectedCustomerSupport && <EditCustomerSupportModal
        open={editModalOpen}
        handleClose={handleEditClose}
        device={selectedCustomerSupport}
        showSnackbar={showSnackbar}
        fetchTrucks={fetchTrucks}
      />}
      <DataTable
        title="Customer Support Repair/Replacement List"
        columns={[
          { key: 'technical_complaint', label: 'R/R #', render: (sale) => (
            <span onClick={() => handleViewSaleDetail(sale.technical_complaint)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{sale.technical_complaint}</span>
          )},
          { key: 'customer_support_complaint', label: 'CS Complaint #' },
          { key: 'id', label: 'Technical Complaint #' },
          { key: 'amount', label: 'Amount' },
          { key: 'document_url', label: 'Document', render: (sale) => sale.document_url ? (
            <a href={`https://crm-backend.monit.tech/${sale.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
          ) : <span style={{ color: '#999' }}>Not Available</span> },
          { key: 'close_at', label: 'Close At', render: (sale) => (
            <div style={{ maxHeight: '80px', overflow: 'auto' }}>{sale.status === 'Close' && sale.updated_at?.slice(0, 19).replace("T", " ")}</div>
          )},
        ]}
        rows={filteredCustomerSupportData}
        toolbarActions={<>
          <TextField size="small" placeholder="Search Vehicle..." value={searchVehicle} onChange={(e) => setSearchVehicle(e.target.value)} />
          <Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>
        </>}
        renderActions={(sale) => <>
          <IconButton color="secondary" size="small" onClick={() => handleEditOn(sale)} sx={{ padding: '6px' }} disabled={sale.status === 'Close'}><EditIcon /></IconButton>
          <IconButton color="error" size="small" onClick={() => handleDeleteClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sale.status === 'Complete'}><DeleteIcon /></IconButton>
          <IconButton color="primary" size="small" onClick={() => handleSendClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === sale.id}>
            {sendingEmailId === sale.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          </IconButton>
          <Select value={sale.status} onChange={(e) => handleStatusChange(sale.id, e.target.value, sale)} size="small" sx={{ ml: 1, minWidth: 100 }}>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Complete">Complete</MenuItem>
          </Select>
        </>}
      />
          {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
      <Dialog open={saleModalOpen} onClose={() => setSaleModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Sale Details</DialogTitle>
        <DialogContent>
          {selectedSale ? (
            <Box>
              <Typography variant="body1"><strong>Resource Name:</strong> {selectedSale.resource_name}</Typography>
              <Typography variant="body1"><strong>Location:</strong> {selectedSale.location}</Typography>
              <Typography variant="body1"><strong>Scope:</strong> {selectedSale.scope}</Typography>
              <Typography variant="body1"><strong>Part Description:</strong> {selectedSale.part_description}</Typography>

            </Box>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSaleModalOpen(false)} color="primary">Close</Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}



const editCustomerSupportSchema = z.object({
  amount: z.string().min(1, "Amount is required"),
});

const EditCustomerSupportModal = ({
  open,
  handleClose,
  device,
  showSnackbar,
  fetchTrucks,
}) => {
  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title="Edit Customer Support"
      schema={editCustomerSupportSchema}
      defaultValues={{ amount: device?.amount?.toString() ?? "" }}
      onSubmit={async (data) => {
        const fd = new FormData();
        Object.entries(data).forEach(([k, v]) => {
          if (v !== null && v !== undefined && v !== "") fd.append(k, v);
        });
        try {
          await updateCustomerSupportRepairReplacement(device.id, fd);
          showSnackbar("Customer Support Replacement/Repair updated successfully", "success");
          fetchTrucks();
        } catch (err) {
          showSnackbar("Failed to update Customer Support", "error");
          throw err;
        }
      }}
      submitLabel="Update"
      width={600}
    >
      {({ control }) => (
        <>
          <Box sx={{ mb: 2, p: 1.5, bgcolor: "action.hover", borderRadius: 1, display: "flex", gap: 3, flexWrap: "wrap" }}>
            <Typography variant="caption">Created At: {device?.created_at?.slice(0, 19).replace("T", " ")}</Typography>
            <Typography variant="caption">Updated At: {device?.updated_at?.slice(0, 19).replace("T", " ")}</Typography>
          </Box>

          <RHFTextField control={control} name="amount" label="Amount" required />

          {device?.remarks && (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500 }}>Remarks</Typography>
              <Typography variant="body2">{device.remarks}</Typography>
            </Box>
          )}
        </>
      )}
    </FormModal>
  );
};

export default EditCustomerSupportModal;
